/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';

/**
 * 
 * @export
 * @interface CopyLead201Response
 */
export interface CopyLead201Response {
    /**
     * 
     * @type {FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead}
     * @memberof CopyLead201Response
     */
    data?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead;
}

/**
 * Check if a given object implements the CopyLead201Response interface.
 */
export function instanceOfCopyLead201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CopyLead201ResponseFromJSON(json: any): CopyLead201Response {
    return CopyLead201ResponseFromJSONTyped(json, false);
}

export function CopyLead201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyLead201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON(json['data']),
    };
}

export function CopyLead201ResponseToJSON(value?: CopyLead201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON(value.data),
    };
}

